export default "/static/assets/6ac8a5979f178488.png"